import { Component } from '@verndale/core';

class Field extends Component {
  setupDefaults() {
    this.dom = {
      input: this.el.querySelector('.field__input'),
      textarea: this.el.querySelector('.field__textarea'),
      password: this.el.querySelector('.field__password'),
      select: this.el.querySelector('.field__select')
    };

    this.handleChange();
  }

  addListeners() {
    if (this.dom.input) {
      this.dom.input.addEventListener('change', () => this.handleChange());
      this.dom.input.addEventListener('input', () => this.handleChange());
    } else if (this.dom.textarea) {
      this.dom.textarea.addEventListener('change', () => this.handleChange());
      this.dom.textarea.addEventListener('input', () => this.handleChange());
    } else if (this.dom.select) {
      this.dom.select.addEventListener('change', () => this.handleChange());
    }

    if (this.dom.password) {
      this.dom.password.addEventListener('click', event =>
        this.handlePassword(event)
      );
    }
  }

  handlePassword(event) {
    event.preventDefault();
    if (this.dom.password.classList.contains('show')) {
      this.dom.input.type = 'password';
      this.dom.password.classList.remove('show');
      this.dom.password.setAttribute(
        'aria-label',
        this.dom.password.dataset.showPassword
      );
    } else {
      this.dom.input.type = 'text';
      this.dom.password.classList.add('show');
      this.dom.password.setAttribute(
        'aria-label',
        this.dom.password.dataset.hidePassword
      );
    }
  }

  handleChange() {
    if (this.dom.input) {
      if (this.dom.input.type !== 'date') {
        this.el.classList.toggle('field--filled', this.dom.input.value);
      } else {
        this.el.classList.add('field--filled');
      }
    } else if (this.dom.textarea) {
      this.el.classList.toggle('field--filled', this.dom.textarea.value);
    } else if (this.dom.select) {
      this.el.classList.toggle('field--filled', this.dom.select.value !== '');
    }
  }
}

export default Field;
